module.exports = {"410883001":"大定街道","410883002":"会昌街道","410883003":"河雍街道","410883004":"河阳街道","410883100":"化工镇","410883101":"南庄镇","410883102":"城伯镇","410883103":"谷旦镇","410883104":"赵和镇","410883105":"西虢镇","410883201":"槐树乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410883.json
// module id = 1471
// module chunks = 0